import React from "react";
import { Link } from "react-router-dom";
import { PageHeader, SectionPad } from "../../components/ui-extras";
import { ChartLine, UsersFour, ArrowRight } from "@phosphor-icons/react";

/**
 * Sales Tools landing hub — two big cards to pick between:
 *   1. Prospects CRM (`/sales-tools/crm`)
 *   2. Competitive Pricing Analyzer (`/sales-tools/analyzer`)
 */
export default function SalesToolsHub() {
  return (
    <SectionPad>
      <PageHeader
        title="Sales Tools"
        subtitle="PRE-SALE WORKFLOWS · track prospects, analyse competitor pricing, pitch savings"
      />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5 max-w-4xl">
        <Link
          to="/sales-tools/crm"
          className="gf-card gf-card-body group hover:border-zinc-500 transition-colors"
          data-testid="hub-card-crm"
        >
          <div className="flex items-start gap-4">
            <div className="p-3 bg-zinc-900 text-white">
              <UsersFour size={28} weight="duotone"/>
            </div>
            <div className="flex-1">
              <div className="overline mb-1">CRM</div>
              <h3 className="text-lg mb-2 group-hover:underline">Prospects</h3>
              <p className="text-sm text-zinc-600">
                Add prospects, log phone calls with timestamps, and track every lead
                through the pipeline. Onboard signed prospects straight into the
                Customers workflow.
              </p>
              <div className="mt-3 text-xs font-mono text-zinc-500 group-hover:text-zinc-900 inline-flex items-center gap-1">
                OPEN PROSPECTS <ArrowRight size={12}/>
              </div>
            </div>
          </div>
        </Link>

        <Link
          to="/sales-tools/analyzer"
          className="gf-card gf-card-body group hover:border-zinc-500 transition-colors"
          data-testid="hub-card-analyzer"
        >
          <div className="flex items-start gap-4">
            <div className="p-3 bg-emerald-700 text-white">
              <ChartLine size={28} weight="duotone"/>
            </div>
            <div className="flex-1">
              <div className="overline mb-1">COMPETITIVE PRICING</div>
              <h3 className="text-lg mb-2 group-hover:underline">Price Analyzer</h3>
              <p className="text-sm text-zinc-600">
                Upload a prospect's existing fuelling history or a competitor's price
                list. System matches against our pricing and produces a projected
                annual savings pitch, plus the top 20 cheapest getFuel stations.
              </p>
              <div className="mt-3 text-xs font-mono text-zinc-500 group-hover:text-zinc-900 inline-flex items-center gap-1">
                OPEN ANALYZER <ArrowRight size={12}/>
              </div>
            </div>
          </div>
        </Link>
      </div>
    </SectionPad>
  );
}
